/**
 * 价格和利润率双向计算Hook
 */

import { useEffect } from 'react';
import { FormInstance } from 'antd';
import { calculatePriceFromMargin, calculateMarginFromPrice } from '../utils/pricingCalculations';

export const usePriceMarginSync = (
    form: FormInstance,
    landedCost: number,
    fbaFee: number,
    currentStorageFee: number,
    referralRate: number,
    returnRate: number,
    otherCostRate: number,
    lastChanged: 'price' | 'margin',
    price: number | undefined,
    profitMargin: number | undefined
) => {
    useEffect(() => {
        // 总固定成本 = 完税成本 + FBA费 + 仓储费
        const totalFixedCost = landedCost + fbaFee + currentStorageFee;

        // 如果成本还没计算出来，不进行同步
        if (totalFixedCost <= 0) return;

        if (lastChanged === 'margin') {
            // 如果利润率为空（用户清空了输入），则不计算价格，或者也可以选择清空价格
            // 这里我们选择：如果利润率未定义，则不更新价格；如果显式为0，则计算
            if (profitMargin === undefined || profitMargin === null) {
                return;
            }

            const calculatedPrice = calculatePriceFromMargin(
                totalFixedCost,
                profitMargin,
                referralRate,
                returnRate,
                otherCostRate
            );

            if (calculatedPrice !== null && Math.abs(calculatedPrice - (price || 0)) > 0.01) {
                form.setFieldsValue({ price: parseFloat(calculatedPrice.toFixed(2)) });
            }
        } else {
            // 如果价格为空，不计算利润率
            if (price === undefined || price === null) {
                return;
            }

            const currentPrice = price;
            if (currentPrice > 0) {
                const calculatedMargin = calculateMarginFromPrice(
                    currentPrice,
                    totalFixedCost,
                    referralRate,
                    returnRate,
                    otherCostRate
                );

                if (Math.abs(calculatedMargin - (profitMargin || 0)) > 0.1) {
                    form.setFieldsValue({ profit_margin: parseFloat(calculatedMargin.toFixed(1)) });
                }
            }
        }
    }, [landedCost, fbaFee, currentStorageFee, referralRate, returnRate, otherCostRate, lastChanged, price, profitMargin, form]);
};
